import { memo } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Link from "@/v2-backoffice-client/components/link"

// An item can be a plain label or a label that links somewhere (e.g. a tenant
// name linking to its panel). `to` accepts the same partial-href form as the
// table cell links (e.g. "?v=tenant:123").
export type TruncatedListItem = { label: string; to?: string }

export type TruncatedListProps = {
  items: (string | TruncatedListItem)[]
  className?: string
}

function normalize(item: string | TruncatedListItem): TruncatedListItem {
  return typeof item === "string" ? { label: item } : item
}

function TruncatedList(props: TruncatedListProps) {
  const { items, className } = props

  if (items.length === 0) return null
  const [first, ...rest] = items.map(normalize)

  return (
    <span className={cn("truncated-list", className)}>
      {first.to ? (
        <Link
          to={first.to}
          className="truncated-list-name"
          title={first.label}
          onClick={(e) => e.stopPropagation()}
        >
          {first.label}
        </Link>
      ) : (
        <span className="truncated-list-name" title={first.label}>
          {first.label}
        </span>
      )}

      {rest.length > 0 && (
        <span
          className="truncated-list-badge"
          title={rest.map((item) => item.label).join("\n")}
        >
          +{rest.length}
        </span>
      )}
    </span>
  )
}

export default memo(TruncatedList)
